<template>
    <div class="photograph_detail_info">
        <el-row :gutter="20">
            <!-- 图片列表列 -->
            <el-col :lg="11" :md="12" ref="imgList">
                <div class="detail_images_box">
                    <!-- 小图列表-->
                    <img-list
                        :md-img="mdImg"
                        :img-list="imgs"
                        @change-md="handleMdChange">
                    </img-list>
                    <!-- 详情说明 -->
                    <div class="photo_detail_explain">
                        <!-- 标题区域 -->
                        <div class="photo_detail_explain_title">
                            <span>服务介绍</span>
                        </div>
                        <!-- 内容区域 -->
                        <div class="photo_detail_explain_content">
                            <div v-html="info.intro"></div>
                        </div>
                    </div>
                </div>
            </el-col>
            <!-- 选项表单部分 -->
            <el-col :lg="13" :md="12">
                <div class="detail_form_box">
                    <div class="detail_form_heading">
                        <div>
                            <div class="detail_form_eyebrow">
                                <i class="el-icon-camera" aria-hidden="true"></i>
                                摄影预约
                            </div>
                            <h1 class="detail_form_title">{{info.title}}</h1>
                        </div>
                    </div>
                    <aside v-if="serviceItem && serviceItem.studioRecruitmentPending" class="studio-cooperation-notice" role="status" aria-label="影棚合作公告">
                        <i class="el-icon-bell" aria-hidden="true"></i>
                        <div><b>招募合作影棚</b><p>合作区域：<br>首期开放珠海金湾区、香洲区</p></div>
                    </aside>
                    <div v-if="showCampusCertificationPrompt" class="campus-qualification-notice" role="status">
                        <div>
                            <b>完成校园认证即可享受校园服务</b>
                            <p>认证通过后即可提交校园场地预约。</p>
                        </div>
                        <el-button size="small" type="warning" plain @click="openCampusCertification">去完成校园认证</el-button>
                    </div>
                    <el-form 
                        label-width="180px"
                        label-position="left"
                        :model="form"
                        :rules="rules"
                        ref="addForm">
                        <!-- 拍摄价格 -->
                        <el-form-item 
                            label="价格">
                            <div v-if="campusPrice.promotional" class="campus-price-promotion">
                                <span class="campus-price-kicker">校园专享</span>
                                <strong><small>¥</small>{{quote.totalAmount}}</strong>
                                <span class="detail_form_price_unit">元</span>
                                <del>¥{{campusPrice.regularTotalAmount}}</del>
                            </div>
                            <div v-else class="detail_form_price">
                                <span>¥</span>
                                <span>{{info.price}}</span>
                                <span class="detail_form_price_unit">{{info.unit}}</span>
                            </div>
                        </el-form-item>
                        <!-- 拍摄风格 -->
                        <el-form-item 
                            label="拍摄风格"
                            prop="style_id">
                            <ul class="detail_form_select_list">
                                <!-- 选中样式 class="active" -->
                                <li v-for="(item,index) in info.style"
                                    :key="index"
                                    :class="{active:form.style_id===item.id}">
                                    <button type="button"
                                        :aria-pressed="form.style_id===item.id"
                                        @click="selectStyle(item.id)">{{item.name}}</button>
                                </li>
                            </ul>
                        </el-form-item>
                        <!-- 拍摄日期 -->
                        <el-form-item 
                            label="拍摄日期"
                            prop="dateValue">
                            <el-date-picker
                                v-model="form.dateValue"
                                type="date"
                                format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                @change="handleDate">
                            </el-date-picker>
                        </el-form-item>
                        <!-- 拍摄时间 -->
                        <el-form-item 
                            label="拍摄时间"
                            prop="startTime">
                            <div class="detail_form_select_time">
                                <el-select :value="selectedShootHour" :disabled="!form.dateValue" placeholder="小时" aria-label="拍摄小时"
                                    @visible-change="refreshShootClock" @change="selectShootHour">
                                    <el-option v-for="hour in shootHourOptions" :key="hour" :label="hour + ' 时'" :value="hour" />
                                </el-select>
                                <span aria-hidden="true">:</span>
                                <el-select :value="form.startTime ? form.startTime.slice(3, 5) : ''" :disabled="!form.dateValue || !selectedShootHour" placeholder="分钟" aria-label="拍摄分钟"
                                    @visible-change="refreshShootClock" @change="selectShootMinute">
                                    <el-option v-for="minute in shootMinuteOptions" :key="minute" :label="minute + ' 分'" :value="minute" />
                                </el-select>
                            </div>
                        </el-form-item>
                        <!-- 拍摄场地 -->
                        <el-form-item 
                            label="拍摄场地"
                            prop="space_id" v-if="booking.venues.length">
                            <photography-venue-picker
                                v-model="form.space_id"
                                :venues="booking.venues"
                                @change="handleVenueChange" />
                        </el-form-item>
                        <!-- 胶卷选择 -->
                        <el-form-item 
                            label="套餐"
                            prop="film_type">
                            <ul class="detail_form_select_list">
                                <li v-for="(item,index) in info.film"
                                    :key="index"
                                    :class="{active:form.film_type===item.id}">
                                    <button type="button"
                                        :aria-pressed="form.film_type===item.id"
                                        @click="selectFilm(item.id)">{{item.name}}</button>
                                </li>
                            </ul>
                        </el-form-item>
                        <!-- 化妆师 -->
                        <el-form-item 
                            label="化妆师"
                            prop="need_dresser">
                            <ul class="detail_form_select_list">
                                <li :class="{active:form.need_dresser==='1'}">
                                    <button type="button"
                                        :aria-pressed="form.need_dresser==='1'"
                                        @click="selectDresser('1')">需要</button>
                                </li>
                                <li :class="{active:form.need_dresser==='0'}">
                                    <button type="button"
                                        :aria-pressed="form.need_dresser==='0'"
                                        @click="selectDresser('0')">不需要</button>
                                </li>
                            </ul>
                        </el-form-item>
                        <!-- 拍摄人数 -->
                        <el-form-item 
                            label="拍摄人数"
                            prop="photography_number">
                            <el-input-number
                                v-model="form.photography_number"
                                :min="peopleRange ? peopleRange.min : 1"
                                :max="peopleRange ? peopleRange.max : 1"
                                :disabled="!peopleRange"
                                @change="handleNum">
                            </el-input-number>
                            <span v-if="peopleRange">基础人数{{ peopleRange.min }}人 · 可预约{{ peopleRange.min }}～{{ peopleRange.max }}人，超出基础人数按每位额外人数单价收费</span>
                        </el-form-item>
                        <el-form-item label="摄影师专业身份码" prop="photographerIdentityCode">
                            <div class="identity-input-column">
                                <div v-if="photographerConfirmation.status === 'selected'" class="identity-selected-control photographer-identity-card">
                                    <img v-if="photographerConfirmation.creator.portrait && photographerConfirmation.creator.portrait.accessUrl && !photographerConfirmation.portraitFailed" :src="photographerConfirmation.creator.portrait.accessUrl" alt="摄影师真人形象照" @error="handleProfessionalIdentityPortraitError('photographer')"><i v-else class="el-icon-user-solid" aria-hidden="true"></i>
                                    <div><b>{{photographerConfirmation.creator.realNameMasked}}</b><span>摄影师 · {{photographerConfirmation.creator.professionalIdentityCode}}</span></div>
                                    <button type="button" class="identity-remove" aria-label="移除已选摄影师" @click="removeProfessionalIdentitySelection('photographer')"><i class="el-icon-close" aria-hidden="true"></i></button>
                                </div>
                                <div v-else class="identity-search-wrap" @click.stop>
                                    <div class="identity-code-input"><el-input v-model.trim="form.photographerIdentityCode" maxlength="8" placeholder="选填，不填则公开接单" @input="clearProfessionalIdentityConfirmation('photographer')"></el-input><el-button :loading="photographerConfirmation.status === 'loading'" :disabled="!isProfessionalIdentityCode(form.photographerIdentityCode)" @click="confirmProfessionalIdentity('photographer')">搜索</el-button></div>
                                    <div v-if="photographerConfirmation.creator" class="identity-search-dropdown" role="listbox" aria-label="摄影师搜索结果">
                                        <button type="button" role="option" :aria-disabled="!photographerConfirmation.creator.eligibleForInvitation" :class="{ ineligible: !photographerConfirmation.creator.eligibleForInvitation }" @click="selectProfessionalIdentity('photographer')">
                                            <img v-if="photographerConfirmation.creator.portrait && photographerConfirmation.creator.portrait.accessUrl && !photographerConfirmation.portraitFailed" :src="photographerConfirmation.creator.portrait.accessUrl" alt="摄影师真人形象照" @error="handleProfessionalIdentityPortraitError('photographer')"><i v-else class="el-icon-user-solid" aria-hidden="true"></i>
                                            <span><b>{{photographerConfirmation.creator.realNameMasked}}</b><small>摄影师 · {{photographerConfirmation.creator.professionalIdentityCode}}</small><em v-if="!photographerConfirmation.creator.eligibleForInvitation">该摄影师当前不可邀约</em></span>
                                        </button>
                                    </div>
                                </div>
                                <p v-if="photographerConfirmation.error" class="identity-confirmation-error" role="alert">{{photographerConfirmation.error}}</p>
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="form.need_dresser === '1'"
                            label="化妆师专业身份码"
                            prop="makeupArtistIdentityCode">
                            <div class="identity-input-column">
                                <div v-if="makeupArtistConfirmation.status === 'selected'" class="identity-selected-control makeup-identity-card">
                                    <img v-if="makeupArtistConfirmation.creator.portrait && makeupArtistConfirmation.creator.portrait.accessUrl && !makeupArtistConfirmation.portraitFailed" :src="makeupArtistConfirmation.creator.portrait.accessUrl" alt="化妆师真人形象照" @error="handleProfessionalIdentityPortraitError('makeupArtist')"><i v-else class="el-icon-user-solid" aria-hidden="true"></i>
                                    <div><b>{{makeupArtistConfirmation.creator.realNameMasked}}</b><span>化妆师 · {{makeupArtistConfirmation.creator.professionalIdentityCode}}</span></div>
                                    <button type="button" class="identity-remove" aria-label="移除已选化妆师" @click="removeProfessionalIdentitySelection('makeupArtist')"><i class="el-icon-close" aria-hidden="true"></i></button>
                                </div>
                                <div v-else class="identity-search-wrap" @click.stop>
                                    <div class="identity-code-input"><el-input v-model.trim="form.makeupArtistIdentityCode" maxlength="8" placeholder="选填，不填则公开接单" @input="clearProfessionalIdentityConfirmation('makeupArtist')"></el-input><el-button :loading="makeupArtistConfirmation.status === 'loading'" :disabled="!isProfessionalIdentityCode(form.makeupArtistIdentityCode)" @click="confirmProfessionalIdentity('makeupArtist')">搜索</el-button></div>
                                    <div v-if="makeupArtistConfirmation.creator" class="identity-search-dropdown" role="listbox" aria-label="化妆师搜索结果">
                                        <button type="button" role="option" :aria-disabled="!makeupArtistConfirmation.creator.eligibleForInvitation" :class="{ ineligible: !makeupArtistConfirmation.creator.eligibleForInvitation }" @click="selectProfessionalIdentity('makeupArtist')">
                                            <img v-if="makeupArtistConfirmation.creator.portrait && makeupArtistConfirmation.creator.portrait.accessUrl && !makeupArtistConfirmation.portraitFailed" :src="makeupArtistConfirmation.creator.portrait.accessUrl" alt="化妆师真人形象照" @error="handleProfessionalIdentityPortraitError('makeupArtist')"><i v-else class="el-icon-user-solid" aria-hidden="true"></i>
                                            <span><b>{{makeupArtistConfirmation.creator.realNameMasked}}</b><small>化妆师 · {{makeupArtistConfirmation.creator.professionalIdentityCode}}</small><em v-if="!makeupArtistConfirmation.creator.eligibleForInvitation">该化妆师当前不可邀约</em></span>
                                        </button>
                                    </div>
                                </div>
                                <p v-if="makeupArtistConfirmation.error" class="identity-confirmation-error" role="alert">{{makeupArtistConfirmation.error}}</p>
                            </div>
                        </el-form-item>
                        <!-- 按钮 -->
                        <el-form-item>
                            <el-button 
                                type="warning" 
                                class="add_order"
                                :loading="isSubmitting"
                                :disabled="isSubmitting || noAvailableVenues || campusBlocked || identityConfirmationBlocked"
                                @click="submitOrder('addForm')">立即下单</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <detail-tabs
                    :detail-content="info.description"
                    :image-list="detailImages">
                </detail-tabs>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import photographyBooking from "@/tool/photographyBooking.cjs";
import { getResultMessage } from "@/tool/result";

const {
    PHOTOGRAPHY_APPOINTMENT_STATUS,
    PHOTOGRAPHY_BOOKING_STATUS,
    createAppointmentConfirmationQuery,
    getCampusPricePresentation,
    isDirectedCreatorPortraitFresh,
    isShootDateDisabled,
    isProfessionalIdentityCode,
    isShootAtAllowed,
    normalizeProfessionalIdentityCode,
    resolvePhotographyVenueSelection,
    resolveCampusBookingGate,
} = photographyBooking;

const emptyIdentityConfirmation = () => ({ status: "idle", creator: null, error: "", validating: false });
const IDENTITY_ROLES = {
    photographer: {
        field: "photographerIdentityCode",
        professionalType: "PHOTOGRAPHER",
        label: "摄影师",
    },
    makeupArtist: {
        field: "makeupArtistIdentityCode",
        professionalType: "MAKEUP_ARTIST",
        label: "化妆师",
    },
};

export default {
    name: "PhotographDetailInfo",
    props: {
        serviceItemId: { type: [String, Number], default: "" },
        themeStyles: { type: Array, default: () => [] },
    },
    data() {
        return {
            activeImage: "",
            selectedShootHour: "",
            timePickerNow: new Date(),
            quoteTimer: null,
            appointmentCampusBlocked: false,
            identityConfirmations: {
                photographer: emptyIdentityConfirmation(),
                makeupArtist: emptyIdentityConfirmation(),
            },
            form: {
                style_id: "",
                space_id: [],
                need_dresser: "0",
                film_type: "",
                photography_number: 1,
                dateValue: "",
                startTime: "",
                photographerIdentityCode: "",
                makeupArtistIdentityCode: "",
            },
            rules: {
                style_id: [{ required: true, message: "请选择风格", trigger: "blur" }],
                space_id: [{ required: true, message: "请选择场地", trigger: "change" }],
                need_dresser: [{ required: true, message: "请选择是否需要化妆师", trigger: "blur" }],
                film_type: [{ required: true, message: "请选择套餐", trigger: "blur" }],
                photography_number: [{ required: true, message: "请选择人数", trigger: "blur" }],
                dateValue: [{ required: true, message: "请选择日期", trigger: "change" }],
                startTime: [{ required: true, message: "请选择时间", trigger: "change" }],
            },
            pickerOptions: {
                disabledDate: (date) => isShootDateDisabled(date, new Date(), this.hasDirectedTarget, this.form.need_dresser === "1"),
            },
        };
    },
    computed: {
        ...mapState({
            booking: (state) => state.photography.booking,
            bookingLoadStatus: (state) => state.photography.bookingLoadStatus,
            bookingLoadError: (state) => state.photography.bookingLoadError,
            quoteStatus: (state) => state.photography.quoteStatus,
            quoteError: (state) => state.photography.quoteError,
            appointmentStatus: (state) => state.photography.appointmentStatus,
            appointmentPriceChange: (state) => state.photography.appointmentPriceChange,
            is_login: (state) => state.user.is_login,
        }),
        serviceItem() {
            return this.booking.serviceItem;
        },
        noAvailableVenues() {
            return !!this.serviceItem && !(this.booking.venues || []).length;
        },
        quote() {
            return this.booking.quote;
        },
        imgs() {
            if (!this.serviceItem) return [];
            return Array.from(new Set(this.serviceItem.showcaseImageUrls || []));
        },
        detailImages() {
            return this.serviceItem ? this.serviceItem.detailImageUrls || [] : [];
        },
        mdImg() {
            return this.activeImage || this.imgs[0] || "";
        },
        peopleRange() { return photographyBooking.getPackagePeopleRange(this.selectedPackage); },
        selectedPackage() {
            const packages = this.serviceItem ? this.serviceItem.packages || [] : [];
            return packages.find((item) => item.versionId === this.form.film_type);
        },
        venueSelection() {
            return resolvePhotographyVenueSelection(this.form.space_id, this.booking.venues || []);
        },
        selectedVenue() {
            return this.venueSelection
                ? (this.booking.venues || []).find((item) => item.id === this.venueSelection.venueId)
                : null;
        },
        venueId() {
            return this.venueSelection ? this.venueSelection.venueId : "";
        },
        pointId() {
            return this.venueSelection ? this.venueSelection.pointId : null;
        },
        shootAt() {
            return this.form.dateValue && this.form.startTime
                ? `${this.form.dateValue} ${this.form.startTime}:00`
                : "";
        },
        hasDirectedTarget() {
            const photographerSelected = this.identityConfirmations.photographer.status === "selected"
                && isProfessionalIdentityCode(this.form.photographerIdentityCode);
            const makeupSelected = this.form.need_dresser === "1"
                && this.identityConfirmations.makeupArtist.status === "selected"
                && isProfessionalIdentityCode(this.form.makeupArtistIdentityCode);
            return photographerSelected && (this.form.need_dresser !== "1" || makeupSelected);
        },
        campusGate() {
            return resolveCampusBookingGate({
                required: !!(this.selectedVenue && this.selectedVenue.campusQualificationRequired),
                campusStatus: this.booking.campusStatus,
                quoteStatus: this.quoteStatus,
                hasQuote: !!this.quote,
                quoteError: this.quoteError,
                quote: this.quote,
            });
        },
        campusPrice() {
            return getCampusPricePresentation(
                this.quote || {},
                !!(this.selectedVenue && this.selectedVenue.campusQualificationRequired),
            );
        },
        campusBlocked() {
            return this.appointmentCampusBlocked || this.campusGate.blocked;
        },
        showCampusCertificationPrompt() {
            return !!(
                this.selectedVenue
                && this.selectedVenue.campusQualificationRequired
                && (!this.is_login || this.booking.campusStatus === "UNVERIFIED")
            );
        },
        info() {
            const service = this.serviceItem || {};
            return {
                goods_id: service.serviceItemId || "",
                title: [service.themeName, service.styleName].filter(Boolean).join(" · ") || "摄影服务详情",
                price: this.quote ? this.quote.totalAmount : (this.selectedPackage ? this.selectedPackage.amount : "--"),
                unit: "元",
                style: this.themeStyles.length
                    ? this.themeStyles.map((style) => ({ id: style.serviceItemId, name: style.name }))
                    : (service.serviceItemId ? [{ id: service.serviceItemId, name: service.styleName }] : []),
                open_begin: "00:00",
                open_end: "23:00",
                film: (service.packages || []).map((item) => ({
                    id: item.versionId,
                    name: `${item.name} · ¥${item.amount}`,
                })),
                max_number: this.peopleRange ? this.peopleRange.max : 1,
                allow_order: this.campusBlocked ? 0 : 1,
                intro: service.themeTypeName
                    ? `${service.themeTypeName} / ${service.themeName} / ${service.styleName}`
                    : "服务介绍加载中。",
                description: "",
            };
        },
        shootHourOptions() {
            return Array.from({ length: 24 }, (_, hour) => String(hour).padStart(2, "0"))
                .filter(hour => this.isShootMinuteAllowed(hour, "59"));
        },
        shootMinuteOptions() {
            if (!this.selectedShootHour) return [];
            return Array.from({ length: 60 }, (_, minute) => String(minute).padStart(2, "0"))
                .filter(minute => this.isShootMinuteAllowed(this.selectedShootHour, minute));
        },
        quoteReady() {
            return !!(this.serviceItem && this.form.film_type && photographyBooking.isPackagePeopleCountValid(this.selectedPackage, this.form.photography_number));
        },
        isSubmitting() {
            return this.appointmentStatus === PHOTOGRAPHY_APPOINTMENT_STATUS.SUBMITTING;
        },
        photographerConfirmation() {
            return this.identityConfirmations.photographer;
        },
        makeupArtistConfirmation() {
            return this.identityConfirmations.makeupArtist;
        },
        identityConfirmationBlocked() {
            const roles = this.form.need_dresser === "1"
                ? ["photographer", "makeupArtist"]
                : ["photographer"];
            return roles.some((role) => {
                const config = IDENTITY_ROLES[role];
                const code = normalizeProfessionalIdentityCode(this.form[config.field]);
                const confirmation = this.identityConfirmations[role];
                const creator = confirmation.creator;
                return confirmation.validating || (confirmation.status === "selected" && (!!confirmation.error
                    || !creator
                    || creator.professionalIdentityCode !== code
                    || creator.eligibleForInvitation !== true
                    || !isDirectedCreatorPortraitFresh(creator)));
            });
        },
    },
    components: {
        imgList: () => import("./detailImgList"),
        detailTabs: () => import("@/components/detailTabs"),
        PhotographyVenuePicker: () => import("@/components/photography/PhotographyVenuePicker"),
    },
    watch: {
        serviceItemId: {
            immediate: true,
            handler(value) {
                this.form.space_id = [];
                if (value) this.loadBooking();
            },
        },
        is_login() {
            this.refreshCampusQualification();
            this.scheduleQuote();
        },
        "form.space_id"() {
            this.clearAllProfessionalIdentityConfirmations();
            this.refreshCampusQualification();
            this.scheduleQuote();
        },
        "form.need_dresser": "scheduleQuote",
        "form.film_type"() {
            const count = photographyBooking.clampPackagePeopleCount(this.selectedPackage, this.form.photography_number);
            if (count != null) this.form.photography_number = count;
            this.scheduleQuote();
        },
        "form.photography_number": "scheduleQuote",
        "form.dateValue"(value) {
            this.selectedShootHour = "";
            if (!value) this.form.startTime = "";
            this.revalidateSelectedProfessionalIdentities();
        },
        hasDirectedTarget(value, previous) {
            if (previous && !value) {
                this.form.dateValue = "";
                this.form.startTime = "";
            }
        },
        "form.startTime": "revalidateSelectedProfessionalIdentities",
    },
    mounted() {
        document.addEventListener("click", this.closeProfessionalIdentitySearches);
    },
    methods: {
        ...mapActions([
            "loadPhotographyBooking",
            "refreshPhotographyCampusQualification",
            "checkPhotographyRealNameQualification",
            "requestPhotographyQuote",
            "prevalidatePhotographyProfessionalIdentity",
        ]),
        ...mapMutations([
            "clearPhotographyBooking",
            "invalidatePhotographyQuote",
            "confirmPhotographyPriceChange",
            "setPhotographyAppointmentConfirmationDraft",
        ]),
        loadBooking() {
            this.clearAllProfessionalIdentityConfirmations();
            this.form.space_id = [];
            this.invalidatePhotographyQuote();
            const loading = this.bookingLoadStatus === PHOTOGRAPHY_BOOKING_STATUS.READY
                && this.serviceItem
                && this.serviceItem.serviceItemId === String(this.serviceItemId)
                ? Promise.resolve(this.booking)
                : this.loadPhotographyBooking(this.serviceItemId);
            return loading.then(async (booking) => {
                if ((booking.serviceItem.packages || []).some(pkg => !photographyBooking.getPackagePeopleRange(pkg))) booking = await this.loadPhotographyBooking(this.serviceItemId);
                if (!(booking.serviceItem.packages || []).length || booking.serviceItem.packages.some(pkg => !photographyBooking.getPackagePeopleRange(pkg))) throw new Error('套餐人数范围加载失败，请重试');
                const service = booking.serviceItem;
                const standardPackage = service.packages.find((item) => item.standard) || service.packages[0];
                this.form.style_id = service.serviceItemId;
                this.form.film_type = standardPackage ? standardPackage.versionId : "";
                this.activeImage = service.showcaseImageUrls[0] || "";
                this.scheduleQuote();
            }).catch(() => {
                this.$message.error(this.bookingLoadError || "摄影服务详情加载失败");
            });
        },
        handleMdChange(image) {
            this.activeImage = image;
        },
        handleGet() {
            this.scheduleQuote();
        },
        selectStyle(value) {
            if (value === this.form.style_id) return;
            this.$emit("style-select", value);
        },
        handleDate() {
            this.selectedShootHour = "";
            this.timePickerNow = new Date();
            this.form.startTime = "";
        },
        refreshShootClock(visible) { if (visible) this.timePickerNow = new Date(); },
        isShootMinuteAllowed(hour, minute) {
            return isShootAtAllowed(`${this.form.dateValue} ${hour}:${minute}:00`, this.timePickerNow, this.hasDirectedTarget, this.form.need_dresser === "1");
        },
        selectShootHour(hour) {
            this.selectedShootHour = this.shootHourOptions.includes(hour) ? hour : "";
            this.form.startTime = "";
        },
        selectShootMinute(minute) {
            if (!this.shootMinuteOptions.includes(minute)) return;
            this.form.startTime = `${this.selectedShootHour}:${minute}`;
        },
        refreshCampusQualification() {
            const required = !!(this.selectedVenue && this.selectedVenue.campusQualificationRequired);
            return this.refreshPhotographyCampusQualification({ required }).catch(() => null);
        },
        handleVenueChange() {
            this.scheduleQuote();
        },
        selectFilm(value) {
            this.form.film_type = value;
        },
        selectDresser(value) {
            this.form.need_dresser = value;
            if (value !== "1") {
                this.form.makeupArtistIdentityCode = "";
                this.clearProfessionalIdentityConfirmation("makeupArtist");
            }
        },
        isProfessionalIdentityCode,
        clearProfessionalIdentityConfirmation(role) {
            if (!IDENTITY_ROLES[role]) return;
            this.identityConfirmations[role] = emptyIdentityConfirmation();
        },
        handleProfessionalIdentityPortraitError(role) {
            const confirmation = this.identityConfirmations[role];
            if (!IDENTITY_ROLES[role] || !confirmation || confirmation.portraitFailed) return;
            this.identityConfirmations[role] = { ...confirmation, portraitFailed: true };
        },
        clearAllProfessionalIdentityConfirmations() {
            Object.keys(IDENTITY_ROLES).forEach((role) => this.clearProfessionalIdentityConfirmation(role));
        },
        closeProfessionalIdentitySearches() {
            Object.keys(IDENTITY_ROLES).forEach((role) => {
                if (this.identityConfirmations[role].status === "ready") {
                    this.clearProfessionalIdentityConfirmation(role);
                }
            });
        },
        selectProfessionalIdentity(role) {
            const config = IDENTITY_ROLES[role];
            const confirmation = this.identityConfirmations[role];
            if (!config || !confirmation.creator) return;
            if (!confirmation.creator.eligibleForInvitation) {
                this.$message.warning(`该${config.label}当前不可邀约`);
                return;
            }
            if (!isDirectedCreatorPortraitFresh(confirmation.creator)) {
                this.confirmProfessionalIdentity(role);
                return;
            }
            this.form[config.field] = confirmation.creator.professionalIdentityCode;
            this.identityConfirmations[role] = { ...confirmation, status: "selected", error: "" };
        },
        removeProfessionalIdentitySelection(role) {
            const config = IDENTITY_ROLES[role];
            if (!config) return;
            this.form[config.field] = "";
            this.clearProfessionalIdentityConfirmation(role);
            this.form.dateValue = "";
            this.form.startTime = "";
        },
        identityConfirmationSignature(role) {
            const config = IDENTITY_ROLES[role];
            if (!config) return "";
            return [
                normalizeProfessionalIdentityCode(this.form[config.field]),
                Number(this.serviceItem && this.serviceItem.serviceItemId),
                Number(this.venueId),
                this.shootAt,
                config.professionalType,
            ].join("|");
        },
        confirmProfessionalIdentity(role, preserveSelection = false) {
            const config = IDENTITY_ROLES[role];
            if (!config) return Promise.resolve(null);
            if (!this.is_login) {
                this.$message.warning("您还未登录！");
                return Promise.resolve(null);
            }
            const code = normalizeProfessionalIdentityCode(this.form[config.field]);
            this.form[config.field] = code;
            if (!isProfessionalIdentityCode(code)) {
                this.$message.warning(`${config.label}专业身份码必须为八位字母数字`);
                return Promise.resolve(null);
            }
            if (!this.serviceItem) return Promise.resolve(null);
            if (!this.venueId) {
                this.clearProfessionalIdentityConfirmation(role);
                const bookingForm = this.$refs.addForm;
                if (bookingForm && typeof bookingForm.validateField === "function") {
                    bookingForm.validateField("space_id");
                }
                return Promise.resolve(null);
            }

            const signature = this.identityConfirmationSignature(role);
            const previousConfirmation = this.identityConfirmations[role];
            const keepSelected = preserveSelection && previousConfirmation.status === "selected";
            this.identityConfirmations[role] = keepSelected
                ? { ...previousConfirmation, validating: true, error: "" }
                : { status: "loading", creator: null, error: "", validating: false };
            const prevalidationRequest = {
                professionalIdentityCode: code,
                expectedProfessionalType: config.professionalType,
                serviceItemId: this.serviceItem.serviceItemId,
                venueId: this.venueId,
            };
            if (this.shootAt) prevalidationRequest.shootAt = this.shootAt;
            return this.prevalidatePhotographyProfessionalIdentity(prevalidationRequest).then((creator) => {
                if (signature !== this.identityConfirmationSignature(role)) return null;
                this.identityConfirmations[role] = {
                    status: keepSelected ? "selected" : "ready",
                    creator,
                    error: !creator.eligibleForInvitation && keepSelected
                        ? `该${config.label}在当前时段不可邀约`
                        : "",
                    portraitFailed: false,
                    validating: false,
                };
                if (!creator.eligibleForInvitation) {
                    this.$message.warning(`该${config.label}当前不可邀约`);
                }
                return creator;
            }).catch((error) => {
                if (signature !== this.identityConfirmationSignature(role)) return null;
                const message = getResultMessage(error, "专业身份码验证失败，请稍后重试");
                this.identityConfirmations[role] = keepSelected
                    ? { ...previousConfirmation, status: "selected", error: message, validating: false }
                    : { status: "error", creator: null, error: message, validating: false };
                return null;
            });
        },
        refreshProfessionalIdentityConfirmations() {
            const roles = this.form.need_dresser === "1"
                ? ["photographer", "makeupArtist"]
                : ["photographer"];
            return Promise.all(roles
                .filter((role) => {
                    const config = IDENTITY_ROLES[role];
                    return this.identityConfirmations[role].status === "selected"
                        && isProfessionalIdentityCode(this.form[config.field]);
                })
                .map((role) => this.confirmProfessionalIdentity(role, true)));
        },
        revalidateSelectedProfessionalIdentities() {
            if (!this.shootAt) {
                Object.keys(IDENTITY_ROLES).forEach((role) => {
                    const confirmation = this.identityConfirmations[role];
                    if (confirmation.validating) {
                        this.identityConfirmations[role] = { ...confirmation, validating: false };
                    }
                });
                return Promise.resolve([]);
            }
            return this.refreshProfessionalIdentityConfirmations();
        },
        handleNum() {
            this.scheduleQuote();
        },
        scheduleQuote() {
            clearTimeout(this.quoteTimer);
            if (this.serviceItem) this.invalidatePhotographyQuote();
            if (!this.quoteReady) return;
            this.quoteTimer = setTimeout(() => this.requestQuote(), 180);
        },
        requestQuote() {
            if (!this.quoteReady) return Promise.resolve(null);
            return this.requestPhotographyQuote(this.createDraft()).catch(() => null);
        },
        createDraft() {
            return {
                serviceItemId: this.serviceItem.serviceItemId,
                packageVersionId: this.form.film_type,
                venueId: this.venueId,
                pointId: this.pointId,
                peopleCount: this.form.photography_number,
                makeupSelected: this.form.need_dresser === "1",
                photographerIdentityCode: this.photographerConfirmation.status === "selected"
                    ? this.form.photographerIdentityCode : "",
                makeupArtistIdentityCode: this.form.need_dresser === "1" && this.makeupArtistConfirmation.status === "selected"
                    ? this.form.makeupArtistIdentityCode : "",
                shootAt: this.shootAt,
            };
        },
        openCampusCertification() {
            this.$router.push({ name: "basic", query: { openCampusCertification: "1" } });
        },
        openRealNameVerification() {
            this.$router.push({ name: "basic", query: { openRealNameVerification: "1" } });
        },
        goToLogin() {
            this.$router.push({ name: "login", query: { redirect: this.$route.fullPath } });
        },
        submitOrder(formName) {
            if (this.noAvailableVenues) {
                this.$message.warning("当前暂无可用拍摄场地，暂不能下单");
                return;
            }
            if (!this.is_login) {
                this.goToLogin();
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (!valid) return;
                if (this.campusBlocked) {
                    this.$confirm(this.campusGate.reason, "暂不能下单", {
                        confirmButtonText: "前往校园认证",
                        cancelButtonText: "稍后处理",
                        type: "warning",
                    }).then(this.openCampusCertification).catch(() => {});
                    return;
                }
                this.checkPhotographyRealNameQualification().then((qualified) => {
                    if (qualified) return this.continueSubmitOrder();
                    return this.$confirm("下单前需要先完成实名认证。", "暂不能下单", {
                        confirmButtonText: "前往实名认证",
                        cancelButtonText: "稍后处理",
                        type: "warning",
                    }).then(this.openRealNameVerification).catch(() => {});
                }).catch((error) => {
                    this.$message.error((error && error.message) || "实名认证状态查询失败，请稍后重试");
                });
            });
        },
        continueSubmitOrder() {
            if (!isShootAtAllowed(this.shootAt, new Date(), this.hasDirectedTarget,
                this.form.need_dresser === "1")) {
                this.$message.warning(this.hasDirectedTarget
                    ? "所选服务的计划开始时间必须晚于当前时间"
                    : "拍摄时间必须至少晚于当前时间 24 小时");
                return;
            }
            this.refreshProfessionalIdentityConfirmations().then(() => {
                if (this.identityConfirmationBlocked) {
                    this.$message.warning("请先确认定向创作者且确保当前可邀约");
                    return null;
                }
                const draft = this.createDraft();
                clearTimeout(this.quoteTimer);
                this.quoteTimer = null;
                const ensureQuote = this.quote ? Promise.resolve(this.quote) : this.requestQuote();
                return ensureQuote.then((quote) => {
                    if (!quote) throw new Error("未获取到当前配置的服务端报价");
                    this.setPhotographyAppointmentConfirmationDraft(draft);
                    const confirmationQuery = createAppointmentConfirmationQuery(draft);
                    if (this.$route.query.themeTypeId) confirmationQuery.themeTypeId = this.$route.query.themeTypeId;
                    if (this.$route.query.themeId) confirmationQuery.themeId = this.$route.query.themeId;
                    this.$router.push({
                        name: "photographyAppointmentConfirmation",
                        query: confirmationQuery,
                    });
                });
            }).catch((error) => {
                const response = error && error.response;
                const status = Number(response && (response.status || (response.data && response.data.code)));
                if (status === 403) {
                    this.appointmentCampusBlocked = true;
                    this.$confirm("当前校园资格已失效，请完成认证后再下单。", "暂不能下单", {
                        confirmButtonText: "前往校园认证",
                        cancelButtonText: "稍后处理",
                        type: "warning",
                    }).then(this.openCampusCertification).catch(() => {});
                    return;
                }
                if (this.appointmentPriceChange) {
                    this.$confirm("报价已变化，是否采用服务端最新报价？", "报价变化", {
                        confirmButtonText: "采用最新报价",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        this.confirmPhotographyPriceChange();
                        this.$message.info("已更新价格，请重新点击立即下单");
                    }).catch(() => {});
                    return;
                }
                if (status === 409) {
                    this.refreshProfessionalIdentityConfirmations();
                    this.$message.warning("创作者邀约状态已变化，请按最新结果确认后重试");
                    return;
                }
                if (this.appointmentStatus === PHOTOGRAPHY_APPOINTMENT_STATUS.RECOVERABLE) {
                    this.$message.warning("请求结果暂时未知，请按原提交意图重试，不会重复创建预约。");
                }
            });
        },
    },
    beforeDestroy() {
        document.removeEventListener("click", this.closeProfessionalIdentitySearches);
        clearTimeout(this.quoteTimer);
        this.clearPhotographyBooking();
    },
};
</script>

<style scoped>
/* 预约拍照详情盒子 */
.photograph_detail_info{
    --photo-ink: #1f1d1a;
    --photo-muted: #716c65;
    --photo-accent: #8d9afc;
    --photo-accent-strong: #5d69c4;
    --photo-action: #e6a23c;
    --photo-action-strong: #c9851f;
    --photo-line: #e4e5f0;
    --photo-surface: #fff;
    position: relative;
    z-index: 1;
    margin-bottom: 56px;
}

/* 图片列表区域盒子 */
.detail_form_box{
    padding: 32px 36px 28px;
    background: rgba(255, 255, 255, .94);
    border: 1px solid rgba(221, 223, 239, .92);
    border-radius: 0;
    box-shadow: 0 18px 50px rgba(57, 60, 111, .09);
}
/* 错误提示 */
.detail-form-error{
    display: flex;
    width: 100%;
    height: auto;
    align-items: center;
    margin: 0 0 20px;
    padding: 11px 14px;
    color: #b42318;
    background: #fff6f4;
    border-color: #ffd5cf;
    border-radius: 9px;
    line-height: 1.5;
}
/* 表单标题 */
.detail_form_heading{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 24px;
}
.detail_form_eyebrow{
    margin-bottom: 8px;
    color: var(--photo-accent-strong);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .18em;
}
.detail_form_eyebrow i{
    margin-right: 6px;
    font-size: 14px;
}
.detail_form_title{
    margin: 0;
    color: var(--photo-ink);
    font-family: inherit;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.3;
}
.photo_detail_explain{
    margin-top: 24px;
    background: var(--photo-surface);
    border: 1px solid var(--photo-line);
    border-radius: 16px;
    box-shadow: 0 12px 36px rgba(57, 60, 111, .05);
    overflow: hidden;
}

/* 详细说明区域 */
/* 标题 */
.photo_detail_explain_title>span{
    display: inline-block;
    padding: 18px 22px 12px;
    color: var(--photo-ink);
    font-size: 18px;
    font-weight: 700;
}
/* 内容 */
.photo_detail_explain_content{
    padding: 4px 22px 22px;
    color: #625e58;
    line-height: 1.8;
}

/* 表单区域 */
.detail_form_box>>>.el-form-item__label{
    color: var(--photo-ink);
    font-weight: 600;
    line-height: 44px;
}
.detail_form_box>>>.el-form-item__label:before{
    color: #e03c31 !important;
}
.detail_form_box>>>.el-form-item{
    min-height: 44px;
    margin-bottom: 20px;
}
.detail_form_box>>>.el-form-item__content{
    display: flex;
    min-height: 44px;
    align-items: center;
    line-height: normal;
}
.detail_form_box>>>.el-input__inner,
.detail_form_box>>>.el-cascader .el-input__inner,
.detail_form_box>>>.el-input-number{
    border-color: #d9dbe8;
    border-radius: 9px;
    transition: border-color .2s ease, box-shadow .2s ease;
}
.detail_form_box>>>.el-input__inner{
    min-height: 44px;
    color: var(--photo-ink);
}
.detail_form_box>>>.el-input__inner:hover,
.detail_form_box>>>.el-input__inner:focus{
    border-color: var(--photo-accent);
}
.detail_form_box>>>.el-input__inner:focus{
    box-shadow: 0 0 0 3px rgba(141, 154, 252, .18);
}
.detail_form_box>>>.el-date-editor,
.detail_form_box>>>.photography-venue-picker{
    width: 100%;
}
.studio-cooperation-notice{
    display:flex;
    align-items:flex-start;
    gap:12px;
    margin:0 0 22px;
    padding:14px 16px;
    border:1px solid #f1d9ad;
    border-radius:8px;
    background:#fff9ed;
    color:#946319;
}
.studio-cooperation-notice>i{ margin-top:2px; font-size:18px; }
.studio-cooperation-notice b{ font-size:14px; line-height:20px; }
.studio-cooperation-notice p{ margin:7px 0 0; font-size:12px; line-height:1.8; }
.campus-qualification-notice{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:18px;
    margin:0 0 20px;
    padding:13px 15px;
    color:#8b4b16;
    background:#fff8e9;
    border:1px solid #f7d79e;
    border-radius:10px;
}
.campus-qualification-notice b,
.campus-qualification-notice p{
    display:block;
    margin:0;
}
.campus-qualification-notice p{
    margin-top:4px;
    font-size:12px;
    line-height:1.5;
}
/* 价格 */
.detail_form_price{
    display: flex;
    min-height: 44px;
    align-items: baseline;
    padding: 0;
}
.detail_form_price>span{
    margin-left: 6px;
    color: var(--photo-action-strong);
    font-size: 27px;
    font-weight: 700;
}
.detail_form_price>.detail_form_price_unit{
    margin-left: 10px;
    font-size: 15px;
    color: var(--photo-muted);
    font-weight: 500;
}
.campus-price-promotion{
    display:flex;
    min-height:44px;
    align-items:baseline;
    gap:10px;
    flex-wrap:wrap;
    padding:0;
    color:var(--photo-action-strong);
}
.campus-price-kicker{
    padding:2px 8px;
    color:#b86f16;
    background:#fff5e5;
    border-radius:999px;
    font-size:13px;
    font-weight:700;
    line-height:20px;
}
.campus-price-promotion strong{ font-size:30px; line-height:1; }
.campus-price-promotion strong small{ margin-right:3px; font-size:26px; }
.campus-price-promotion .detail_form_price_unit{
    margin-left:0;
    color:var(--photo-muted);
    font-size:15px;
    font-weight:500;
}
.campus-price-promotion del{
    color:#aaa39a;
    font-size:14px;
}
/* 选项列表 */
.detail_form_select_list{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
}
.detail_form_select_list>li{
    border-radius: 4px;
}
.detail_form_select_list>li>button{
    min-width: 0;
    min-height: 30px;
    padding: 2px 14px;
    color: #4e4a45;
    background: #fff;
    border: 1px solid #d9dbe8;
    border-radius: inherit;
    cursor: pointer;
    font: inherit;
    font-size: 13px;
    line-height: 24px;
    transition: color .2s ease, background-color .2s ease, border-color .2s ease, box-shadow .2s ease;
}
.detail_form_select_list>li>button:hover{
    color: var(--photo-accent-strong);
    border-color: var(--photo-accent);
}
.detail_form_select_list>li>button:focus-visible{
    outline: 2px solid var(--photo-accent);
    outline-offset: 2px;
}
/* 选项列表选中时状态 */
.detail_form_select_list>li.active>button{
    color: #fff;
    background: var(--photo-accent-strong);
    border-color: var(--photo-accent-strong);
    box-shadow: 0 7px 18px rgba(93, 105, 196, .2);
}
/* 拍摄时间区域样式 */
.detail_form_select_time{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
}
.detail_form_select_time > .el-select{
    flex: 1;
    min-width: 0;
}
.identity-code-input{
    display: flex;
    gap: 8px;
}
.identity-input-column{
    flex: 0 1 auto;
    min-width: 0;
}
.identity-code-input>>>.el-input{
    flex: 1;
}
.identity-search-wrap{
    position: relative;
}
.identity-search-dropdown{
    position: absolute;
    z-index: 20;
    top: calc(100% + 6px);
    right: 0;
    left: 0;
    overflow: hidden;
    padding: 6px;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .12);
}
.identity-search-dropdown>button,
.identity-selected-control{
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    color: #303133;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
}
.identity-search-dropdown>button{
    width: 100%;
    border: 0;
    text-align: left;
    cursor: pointer;
}
.identity-search-dropdown>button:hover,
.identity-search-dropdown>button:focus{
    background: #f5f7fa;
    outline: none;
}
.identity-search-dropdown>button.ineligible{
    color: #9b4542;
    background: #fff2f1;
    cursor: not-allowed;
}
.identity-search-dropdown img,
.identity-search-dropdown>button>i,
.identity-selected-control>img,
.identity-selected-control>i{
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 50%;
    object-fit: cover;
}
.identity-search-dropdown>button>i,
.identity-selected-control>i{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--photo-accent-strong);
    background: #fff;
    font-size: 22px;
}
.identity-search-dropdown span,
.identity-selected-control>div{
    min-width: 0;
    flex: 1;
}
.identity-search-dropdown b,
.identity-search-dropdown small,
.identity-search-dropdown em,
.identity-selected-control b,
.identity-selected-control span{
    display: block;
    margin: 0;
    line-height: 1.5;
}
.identity-search-dropdown small,
.identity-search-dropdown em,
.identity-selected-control span{
    font-size: 12px;
}
.identity-search-dropdown em{
    color: #b42318;
    font-style: normal;
}
.identity-selected-control.photographer-identity-card{
    color: #5876bc;
    background: #f6f8ff;
    border-color: #d8e2ff;
}
.identity-selected-control.makeup-identity-card{
    color: #cf557f;
    background: #fff7fa;
    border-color: #f3d7e2;
}
.photographer-identity-card>img{
    border: 2px solid #dbe5ff;
}
.makeup-identity-card>img{
    border: 2px solid #f6dbe5;
}
.photographer-identity-card>i,
.photographer-identity-card span{
    color: #5876bc;
}
.makeup-identity-card>i,
.makeup-identity-card span{
    color: #cf557f;
}
.identity-remove{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    padding: 0;
    color: #606266;
    background: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
}
.identity-remove:hover,
.identity-remove:focus{
    color: #b42318;
    background: rgba(180, 35, 24, .08);
    outline: none;
}
.identity-confirmation-error{
    margin: 8px 0 0;
    color: #F56C6C;
    font-size: 12px;
    line-height: 1.5;
}
/* .detail_form_select_time>.el-date-editor{
    width: 130px;
} */
/* 立即下单按钮 */
.add_order{
    width: 100%;
    min-height: 50px;
    color: #fff;
    background: var(--photo-action);
    border-color: var(--photo-action);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: .08em;
    box-shadow: 0 10px 22px rgba(230, 162, 60, .24);
    transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease;
}
.add_order:hover,
.add_order:focus{
    background: var(--photo-action-strong);
    border-color: var(--photo-action-strong);
    box-shadow: 0 12px 25px rgba(201, 133, 31, .3);
}
.detail_form_box>>>.el-form-item:last-child{
    margin-bottom: 0;
}

@media (max-width: 1199px){
    .detail_form_box{
        padding: 26px 24px;
    }
}

@media (max-width: 991px){
    .detail_form_box{
        margin-top: 28px;
    }
}

@media (max-width: 767px){
    .photograph_detail_info{
        margin-bottom: 36px;
    }
    .detail_form_box{
        margin-top: 20px;
        padding: 22px 18px;
        border-radius: 0;
    }
    .detail_form_title{
        font-size: 26px;
    }
    .detail_form_box>>>.el-form-item__label{
        float: none;
        width: 100% !important;
        padding: 0 0 7px;
        line-height: 1.5;
    }
    .detail_form_box>>>.el-form-item__content{
        margin-left: 0 !important;
    }
    .detail_form_box>>>.el-date-editor,
    .detail_form_box>>>.photography-venue-picker,
    .detail_form_box>>>.el-input-number{
        width: 100%;
    }
}

@media (prefers-reduced-motion: reduce){
    .detail_form_box *,
    .detail_form_box>>>*{
        transition-duration: .01ms !important;
    }
}
</style>
